import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    schoolPage: null,
    publicSchools: [],
    loading: false,
    error: null,
    response: null,
    statestatus: "idle",
};

const schoolPageSlice = createSlice({
    name: "schoolPage",
    initialState,
    reducers: {
        getRequest: (state) => {
            state.loading = true;
        },
        getPageSuccess: (state, action) => {
            state.schoolPage = action.payload;
            state.loading = false;
            state.error = null;
            state.response = null;
        },
        getPublicListSuccess: (state, action) => {
            state.publicSchools = action.payload;
            state.loading = false;
            state.error = null;
            state.response = null;
        },
        stuffDone: (state) => {
            state.loading = false;
            state.error = null;
            state.response = null;
            state.statestatus = "added";
        },
        getFailed: (state, action) => {
            state.response = action.payload;
            state.loading = false;
            state.error = null;
            state.statestatus = "failed";
        },
        getError: (state, action) => {
            state.loading = false;
            state.error = action.payload;
            state.statestatus = "failed";
        },
        underPageControl: (state) => {
            state.loading = false;
            state.response = null;
            state.error = null;
            state.statestatus = "idle";
        },
    },
});

export const {
    getRequest,
    getPageSuccess,
    getPublicListSuccess,
    stuffDone,
    getFailed,
    getError,
    underPageControl,
} = schoolPageSlice.actions;

export const schoolPageReducer = schoolPageSlice.reducer;
